/* global translations */
/* eslint no-underscore-dangle: ["error", { "allow": ["_this"] }] */
import $ from 'jquery';
// import modal from './modal';
import Dialog from 'react-bootstrap-dialog';
import PermissionsStore from '../react/stores/PermissionsStore';

module.exports = {
  showDialog(msg, callback) {
    this.dialog.show({
      body: msg,
      actions: [
        Dialog.CancelAction(), // eslint-disable-line babel/new-cap
        Dialog.OKAction(callback), // eslint-disable-line babel/new-cap
      ],
    });
  },
  checkAuthorizedGeoLocation() {
    const geoPermission = PermissionsStore.get('geolocation');
    if (typeof geoPermission === 'undefined' || geoPermission !== 1) {
      return false;
    }

    return true;
  },
  savePosition(successCallback, errCallback) {
    const error = () => {
      PermissionsStore.set('geolocation', 2);
      // PermissionsStore.emitChange();
      if (errCallback) {
        errCallback();
      }
    };

    // const _this = this;
    const success = (position) => {
      // const latitude = position.coords.latitude; // eslint-disable-line prefer-destructuring
      // const longitude = position.coords.longitude; // eslint-disable-line prefer-destructuring
      const data = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        source: 'geolocation',
      };

      $.post('/apiv1/locations/save', data, (data) => { // eslint-disable-line no-shadow
        if (data.status === 'ok') {
          if (successCallback) {
            successCallback();
          }
          PermissionsStore.set('geolocation', 1);
          // PermissionsStore.emitChange();
        } else if (data.status === 'error') {
          error();
        }
      });
    };

    if (!navigator.geolocation) {
      return;
    }

    navigator.geolocation.getCurrentPosition(success, error);
  },

  init() {
    const _this = this;
    // const $permissionsReminder = $('.permissionsReminder');
    const currentPermission = PermissionsStore.get('geolocation');

    this.showDialog = this.showDialog.bind(this);
    Dialog.setOptions({
      defaultOkLabel: translations['txt: Jā'],
      defaultCancelLabel: translations['txt: Atcelt'],
    });

    // ja iepriekš bloķēta ģeolokācijas atļauja, pārbaudam vai tas nav mainījies,
    // ja atļauta - atjaunojam
    const blockedLocation = () => {
      $(document).on('pjax:click', '.search-closest[data-confirm]', (e) => {
        e.preventDefault();
      });
      $(document).on('click', '.search-closest[data-confirm]', (e) => {
        e.preventDefault();
        e.stopPropagation();

        console.log(111);

        let msg = $(this).data('confirmMsg');
        if (typeof msg === 'undefined') {
          msg = '';
        }
        // const target = $(this).data('target');
        const confirmEvent = $.Event(null, e); // eslint-disable-line babel/new-cap

        const callback = (result) => { // eslint-disable-line vars-on-top
          if (result) {
            const prevPermission = PermissionsStore.get('geolocation'); // eslint-disable-line vars-on-top
            _this.savePosition(() => {
              window.location.href = confirmEvent.target.href;
            }, () => {
              if (prevPermission !== 0) {
                PermissionsStore.showInstructions('geolocation');
              }
            });
          }
        };

        if (currentPermission !== 0) {
          PermissionsStore.showInstructions('geolocation');
          return;
        }
        // modal.confirm(msg, callback);
        this.showDialog(msg, callback);
      });
    };

    console.log(currentPermission);

    if (currentPermission === 0) {
      blockedLocation();
    } else {
      _this.savePosition(() => {
        if (currentPermission === 0) {
          window.location.reload();
        }
      }, blockedLocation);
    }
  },
};
